angular.module('v3sWbtPlayerApp').directive('v3sScale', ['v3sBrowserInfoService', 'v3sContentConfig', '$timeout', function (v3sBrowserInfoService, v3sContentConfig, $timeout) {
    return {
        restrict: 'A',
        scope: {
        },
        link: function (scope, element, attrs) {
            element.attr('data-v3s-annotation-selectable', '');

            var scaleTimer = null;

            function setBodyWidth() {
                var body = document.querySelector("body");
                if (v3sBrowserInfoService.isIosAppViversa()) {
                    switch (window.orientation) {
                        case -90:
                        case 90:
                            body.style.width = "";
                            break;
                        default:
                            body.style.width = (screen.height > screen.width) ? screen.width + "px" : screen.height + "px";
                    }
                }
            }

            function setFrameHeight() {
                if (v3sBrowserInfoService.isIosAppViversa()) {
                    var body = document.querySelector("body");
                    var html = document.querySelector("html");
                    body.style.height = screen.height - 60 + "px";
                    html.style.overflow = "hidden";
                }
            }

            function setScale() {

                if (scaleTimer) {
                    $timeout.cancel(scaleTimer);
                    scaleTimer = null;
                }

                scaleTimer = $timeout(
                    function () {
                        var viewport = document.getElementById("viewport");
                        var scale = screen.availWidth / v3sContentConfig.width;
                        if (scale <= 1 && (!v3sContentConfig.responsive || (window.innerHeight < window.innerWidth) || scale >= v3sContentConfig.minScale)) {
                            viewport.setAttribute("content", "width=" + v3sContentConfig.width);
                        } else {
                            viewport.setAttribute("content", "width=device-width, initial-scale=1");
                        }
                        scaleTimer = null;
                    },
                    150
                );
            }

            setFrameHeight();
            setBodyWidth();
            setScale();

            window.addEventListener("orientationchange", function () {
                setScale();
                setTimeout(function () {
                    setBodyWidth();
                }, 500);
            });
        }
    }
}]);

angular.module('v3sWbtPlayerApp').directive('v3sWarnung', function () {
    return {
        restrict: 'E',
        link: function (scope, element) {
            element.css('display', 'none');
        }
    }
});

angular.module('v3sWbtPlayerApp').directive('v3sPageView', ["$document", "$timeout", "v3sNavigationService", "v3sServiceFinder", function ($document, $timeout, v3sNavigationService, v3sServiceFinder) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var v3sGsapService = v3sServiceFinder.get("v3sGsapService");
            var next = false,
                previous = false;

            //Aktivierte Elemente (Inputs) sollen den Fokus verlieren, sonst werden die letzten Änderungen nicht ausgewertet
            var removeSelection = function(){
                if ($document[0].activeElement) {
                    $document[0].activeElement.blur();
                }
            }

            function isAnswerElement(el){
                var tagName = el.tagName.toLowerCase();
                while (el.parentElement && tagName !== 'v3s-document' && el.className.indexOf('v3s-clickable') === -1) {
                    tagName = el.parentElement.tagName.toLowerCase();
                    el = el.parentElement;
                }
                return el.className.indexOf('v3s-clickable') !== -1;
            }
            if (v3sGsapService) {
                v3sGsapService.createDraggable(element[0], {
                    type: "x",
                    dragResistance: 0.6,
                    cursor: "auto",
                    allowContextMenu: true,
                    allowEventDefault: true,
                    dragClickables: false,
                    clickableTest: function(el){
                        return isAnswerElement(el);
                    },
                    onClick: function (evt) {
                        removeSelection();
                        //evt.stopPropagation();
                        //evt.preventDefault();
                    },
                    onDragStart: function () {
                        next = !!v3sNavigationService.getNextPageState();
                        previous = !!v3sNavigationService.getPreviousPageState();
                    },
                    onDragEnd: function () {
                        var direction = this.getDirection("start");
                        var drag = Math.abs(this.endX) > 50;

                        if (drag) {
                            removeSelection();
                        }

                        if (drag && direction.indexOf("left") >= 0 && next) {
                            v3sNavigationService.goToNext();
                        } else if (drag && direction.indexOf("right") >= 0 && previous) {
                            v3sNavigationService.goToPrevious();
                        } else {
                            TweenLite.to(element[0], 0.3, { x: "0" });
                        }

                        $timeout(function () {
                            TweenLite.to(element[0], 0.3, { x: "0" });
                        }, 1000);

                    }
                });
            }

            //Bug Angular / UI Router beim schnellen Wechsel
            scope.$on('$destroy', function () {
                $timeout(function () {
                    element.remove();
                }, 500);
            });
        }
    }
}]);